export const MAX_PREVIEW_FILE_SIZE_BYTES = 50 * 1024 * 1024;
export const DEFAULT_PREVIEW_PARSE_TIMEOUT_MS = 30_000;
export const PDF_PREVIEW_LOAD_TIMEOUT_MS = 30_000;
